module.exports = __webpack_public_path__ + "static/media/mcm@2x.aab65e75.png";